// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"256":"npm.chart.js-bf2cd571","416":"npm.chart.js-373d114a","825":"npm.xlsx"}[chunkId] || chunkId) + "." + {"241":"571cd419","256":"7dd949b7","260":"78469ea7","287":"26599576","416":"df776731","439":"c5d1cddd","672":"a86f4d57","825":"85a51195","875":"8d870179"}[chunkId] + ".js";
};